import React from 'react';

import { Button, PrimaryButton, useTranslation } from '@testsigma/atoms';

interface SelectMetadataFormActionsProps {
  handleClose: (event: React.SyntheticEvent) => void;
  onConfirmSelection: () => void; // Callback for button click
}

const SelectMetadataFormActions: React.FC<SelectMetadataFormActionsProps> = (
  props: SelectMetadataFormActionsProps,
) => {
  const { handleClose, onConfirmSelection } = props;

  const { t } = useTranslation();

  return (
      <footer className='flex px-4 py-3 text-right justify-end'>
        <Button type='secondary' onClick={handleClose}>
          {t('common.close')}
        </Button>
        <div>
          <PrimaryButton
            type='secondary'
            className='ml-4'
            onClick={(event) => {
              event.preventDefault();
              onConfirmSelection();
            }}
          >
            {t('confirm.selection')}
          </PrimaryButton>
        </div>
    </footer>
  );
};

export { SelectMetadataFormActions };
